import styles from "./brpLogo.module.scss";

const BrpLogo = ({ includeCoach = false }) => {
  return (
    <>
      <span className={styles.brpLogo}>BRP</span>
      {includeCoach && <span className={styles.coach}>Coach</span>}
    </>
  );
};

export default BrpLogo;
